import React from "react";
import { Box, Typography } from "@material-ui/core";

export const Unauthorized = () => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" width="100vw" height="100vh">
            <Box p={4} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                {/* if unauthorized, translations files are not loaded */}
                <Typography variant="h3">UNAUTHORIZED</Typography>
                <Typography variant="body1">
                    Your entrance permission has expired, or you are not authorized to view this page. Please contact
                    your administrator.
                </Typography>
            </Box>
        </Box>
    );
};
